import React from 'react';
import { Typography, FormInstance } from 'antd';
import { useTranslation } from 'react-i18next';
import { PackageSizeFormValues } from '../OrderForm/PackageSizeCard';

const { Text } = Typography;

interface PackageSizeProps {
  title: string;
  packageSizeKey: PackageSizeFormValues;
  description: string;
  icon: React.ComponentType<{ width: number; height: number; color?: string }>;
  selectedValue: string;
  onSelect: (value: PackageSizeFormValues) => void;
  form: FormInstance;
}

const PackageSize: React.FC<PackageSizeProps> = ({
  packageSizeKey,
  title,
  icon: Icon,
  description,
  selectedValue,
  onSelect,
}) => {
  const { t } = useTranslation();
  const isSelected = selectedValue === packageSizeKey;
  const iconColor = isSelected ? '#38383E' : '#939496';

  const handleToggle = () => {
    onSelect(packageSizeKey);
  };

  // Split "40 × 35 × 60 cm<br/>Up to 20 kg" into separate dimensions and weight lines
  const [dimensions, weight] = description.split(/<br\s*\/?>/i).map((s) => s.trim());

  return (
    <div
      className={`flex flex-col items-center gap-1.5 rounded-xl p-3 text-center transition-colors cursor-pointer ${
        isSelected
          ? 'border border-solid border-sd-primary bg-sd-primary/10'
          : 'border border-solid border-sd-input bg-sd-card hover:border-sd-primary/50'
      }`}
      onClick={handleToggle}
    >
      <Icon color={iconColor} width={24} height={24} />
      <Text className='text-xs font-semibold text-sd-foreground capitalize'>{t(title)}</Text>
      <span className='text-[10px] leading-tight text-sd-muted-foreground'>{dimensions}</span>
      <span className='text-[10px] leading-tight text-sd-muted-foreground'>{weight}</span>
    </div>
  );
};

export default PackageSize;
